import '../styles/navBar.css'
import { useContext } from 'react'
import { BasketContext } from '../contexts/BasketContexts'
import { Link } from 'react-router-dom'

export const NavBar = () =>
{

  const {basket} = useContext(BasketContext)
    return <div class="containerr">
    <nav id="min" class="navbar navbar-expand-lg">
      <div class="container-fluid">
      <Link to = "/" className='navbar-brand'><img class="turtle" src={require("../img/nav/turtle-text.png")} alt="turtle"></img></Link>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          </ul>

          <Link to = "/Basket"><img class="size" src={require("../img/nav/basket.png")} alt="trolley"></img></Link>
          {basket.length > 0 && <span class="badge">{basket.length}</span>}
        </div>
      </div>
    </nav>
  </div>
    
}
